export function matchStrings(search, base) {
    if (!search)
        return true;
    return base.toLowerCase().includes(search);
}
